/* Update qty button text without destroying LoaderButton inner structure */
function setQtyBtnText(btn, text) {
  var inner = btn.querySelector('.loader-button__text');
  if (inner) {
    inner.textContent = text;
  } else {
    btn.textContent = text;
  }
}

/* Show/hide loader on a LoaderButton */
function setQtyBtnLoading(btn, loading) {
  if (loading) {
    btn.setAttribute('aria-busy', 'true');
  } else {
    btn.removeAttribute('aria-busy');
  }
}

function syncCartQtyFromData(cart) {
  if (!cart || !cart.items) return;
  var qtyMap = {};
  cart.items.forEach(function(item) {
    qtyMap[item.variant_id] = item.quantity;
  });
  document.querySelectorAll('.ctm_atc_btn').forEach(function(wrapper) {
    var btn = wrapper.querySelector('button.atc_with_qty');
    var minusBtn = wrapper.querySelector('.custom_minus');
    if (!btn || !minusBtn) return;
    // Skip buttons that are currently loading (in-flight operation)
    if (btn.getAttribute('aria-busy') === 'true') return;
    var variantId = parseInt(minusBtn.getAttribute('data-proid'));
    var qty = qtyMap[variantId];
    if (qty && qty > 0) {
      setQtyBtnText(btn, qty);
      wrapper.classList.remove('hide');
      var atcBtn = wrapper.closest('.dataFlex') ? wrapper.closest('.dataFlex').querySelector('button.atc') : null;
      if (atcBtn) atcBtn.classList.add('hide');
    } else {
      wrapper.classList.add('hide');
      var atcBtn = wrapper.closest('.dataFlex') ? wrapper.closest('.dataFlex').querySelector('button.atc') : null;
      if (atcBtn) atcBtn.classList.remove('hide');
    }
  });
}

function syncCartQty(cartData) {
  if (cartData && cartData.items) {
    syncCartQtyFromData(cartData);
  } else {
    jQuery.getJSON('/cart.js', function(cart) {
      syncCartQtyFromData(cart);
    });
  }
}

$(document).ready(function(){
// Shared helper: update cart quantity for a variant (used by both plus and minus)
function updateCartQty(variantId, delta, $wrapper, $qtyBtn) {
    if ($qtyBtn.length) setQtyBtnLoading($qtyBtn[0], true);

    jQuery.getJSON('/cart.js', function (cart) {
        var currentQty = 0;
        cart.items.forEach(function (item) {
            if (item.id == variantId) currentQty = item.quantity;
        });

        var newQty = currentQty + delta;
        if (newQty < 0) newQty = 0;

        // If incrementing and item not in cart, use cart/add.js instead
        if (delta > 0 && currentQty === 0) {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] }),
            })
            .then(function(r) { return r.json(); })
            .then(function() { onCartChanged(variantId, 1, $wrapper, $qtyBtn); })
            .catch(function(e) {
                if ($qtyBtn.length) setQtyBtnLoading($qtyBtn[0], false);
                console.error('Error adding to cart:', e);
            });
            return;
        }

        var updates = {};
        updates[variantId] = newQty;

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates }),
        })
        .then(function(response) {
            if (!response.ok) throw new Error('Failed to update cart');
            return response.json();
        })
        .then(function(data) { onCartChanged(variantId, newQty, $wrapper, $qtyBtn, data); })
        .catch(function(error) {
            if ($qtyBtn.length) setQtyBtnLoading($qtyBtn[0], false);
            console.error('Error updating cart:', error);
        });
    });
}

function onCartChanged(variantId, newQty, $wrapper, $qtyBtn, cartData) {
    if (newQty <= 0) {
        $wrapper.addClass('hide');
        $wrapper.siblings('.button.atc').removeClass('hide');
    } else {
        $wrapper.removeClass('hide');
        $wrapper.siblings('.button.atc').addClass('hide');
    }

    // Stop loader first, then set text after a microtask so LoaderButton
    // endTransition animation doesn't overwrite the new quantity value.
    if ($qtyBtn.length) setQtyBtnLoading($qtyBtn[0], false);
    if (newQty > 0) {
        setTimeout(function() { setQtyBtnText($qtyBtn[0], newQty); }, 0);
    }

    // Fetch fresh cart for events if not provided
    if (!cartData) {
        jQuery.getJSON('/cart.js', function(data) { fireCartEvents(data); });
    } else {
        fireCartEvents(cartData);
    }
}

function fireCartEvents(cartData) {
    document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartData } })
    );
    document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartData, replacementDelay: 600 } })
    );
}

// Plus button
$(document).on("click", ".custom_plus", function(e) {
    e.stopPropagation();
    e.preventDefault();
    var $wrapper = $(this).parent('.ctm_atc_btn');
    var $qtyBtn = $wrapper.find('button.atc_with_qty');
    var proId = $wrapper.find('.custom_minus').attr('data-proid');
    if (proId) updateCartQty(proId, 1, $wrapper, $qtyBtn);
});

// Minus button
$(document).on("click", ".custom_minus", function(e) {
    e.stopPropagation();
    e.preventDefault();
    var proId = $(this).attr("data-proid");
    var $wrapper = $(this).parent('.ctm_atc_btn');
    var $qtyBtn = $wrapper.find('button.atc_with_qty');
    if (proId) updateCartQty(proId, -1, $wrapper, $qtyBtn);
});

// Sync qty buttons whenever the cart updates (covers plus, minus, and external cart changes)
document.documentElement.addEventListener('cart:updated', function(e) {
  var cart = e.detail && e.detail.cart;
  syncCartQty(cart);
});

});

var swiper = null;

function initializeSwiper() {
    swiper = new Swiper(".review_blocks_slider", {
        loop: true,
        slidesPerView: 2.5,
        paginationClickable: true,
        spaceBetween: 20,
        breakpoints: {
            1460: {
                slidesPerView: 2.5,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 2.5,
                spaceBetween: 30
            },
            741: {
                slidesPerView: 1,
                spaceBetween: 30
            }
        }
    });
}

$(document).ready(function() {
    initializeSwiper(); // Initialize Swiper on document ready

    // Update Swiper when window is resized
    $(window).on('resize', function() {
        if (swiper !== null) {
            swiper.destroy(true, true); // Destroy Swiper instance
        }
        initializeSwiper(); // Reinitialize Swiper with updated settings
    });
});



$(document).ready(function(){
// $('.cartdrawer-upsell-wrap').slick({
//       dots: false,
//     slidesToShow: 1
//   });
// var isALARendered;
// function ALAcheck() {
//   isALARendered = setInterval(function () {
//     customALA()
//   }, 200);
// }
// ALAcheck();
// function customALA() {
// var selector = $('.cartdrawer-upsell-wrap');
//   if(selector.length > 0) {
//     // clearInterval(isALARendered); 
//     if(!$('.cartdrawer-upsell-wrap').hasClass("slick-initialized")){
//    $('.cartdrawer-upsell-wrap').slick({
//       dots: false,
//     slidesToShow: 1,
//      arrows: true
//   });
//     }
    
//      if($(".cartdrawer-upsell-wrap .upsell-pro-list.ajaxcart__product").length < 1)
//     {
//       $(".upsell_products_drawer").css("display","none");
//     }
//   }  
// }
  
// upsell multiple add in cart-drawer

$(document).on('click', '.addcart-btn',function(){
  var pro_id = $(this).data("pro-id");
  let arr = [];
  arr.push({id: pro_id, quantity: 1 });   
  let formData = {'items': arr};
  fetch('/cart/add.js', {
              body: JSON.stringify(formData),
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With':'xmlhttprequest'
              },
              method: 'POST'
            }).then((response) => {
              return response.json();
            }).then((res) => {
     setTimeout(function() {
       jQuery.getJSON('/cart.js', function(cartData) {
         document.documentElement.dispatchEvent(
           new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartData } })
         );
         document.documentElement.dispatchEvent(
           new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartData, replacementDelay: 0 } })
         );
       });
     }, 600);
setTimeout(function(){

    if($(".cartdrawer-upsell-wrap .upsell-pro-list.ajaxcart__product").length < 1)
    {
      $(".upsell_products_drawer").css("display","none");
    }
  },500);
            if(res.status && res.status == 422){
              console.log("Inventory Error !");
            }else{
              console.log("Success !");
              }
            }).catch((err) => {
              /* uh oh, we have error. */
              console.error(err)
            });
});

});



  // function updateUnitsLeft() {
  //   const min = 50;
  //   const max = 75;
  //   const randomUnits = Math.floor(Math.random() * (max - min + 1)) + min;
  //   document.getElementById('units-left').innerText = `Last ${randomUnits} Units Left`;
  // }
  // updateUnitsLeft();

  // setInterval(updateUnitsLeft, 180000);




  if(document.body.classList.contains('template-product')){
    function toggleAccordion(button) {
    const content = button.nextElementSibling;
    content.classList.toggle('open');
    button.classList.toggle('active');
  }
  }

// Hide cart count badge when 0
function updateCartCountVisibility() {
  document.querySelectorAll('cart-count.header__cart-count').forEach(function(el) {
    el.style.display = (el.textContent.trim() === '0' || el.textContent.trim() === '') ? 'none' : '';
  });
}
document.addEventListener('DOMContentLoaded', updateCartCountVisibility);
document.documentElement.addEventListener('cart:updated', updateCartCountVisibility);
document.documentElement.addEventListener('cart:refresh', updateCartCountVisibility);

// Bridge: relay cart:updated → cart:refresh so the cart drawer re-renders
// The drawer only listens to cart:refresh; its _rerenderCart fallback
// auto-fetches section HTML when the event detail has no sections data.
document.documentElement.addEventListener('cart:updated', function(e) {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: e.detail }));
});

// Sync all product card qty counters with actual cart on page load
document.addEventListener('DOMContentLoaded', syncCartQty);